<div class="mb-1 fs-6 txt-bold">{{ label() }}</div>
<div>
    <ckeditor [editor]="Editor"
              (ready)="onReadyEditor($event)"
              [formControl]="control()"
              [config]="config"/>
</div>

